import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPasswordSchema } from '../../lib/validators/authSchemas';
import { useForgotPasswordMutation } from '../../features/auth/authApi';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(forgotPasswordSchema) });

  const onSubmit = async (values) => {
    // Always 200 regardless of whether the email is registered —
    // enumeration-safe, so there's nothing to branch on here.
    await forgotPassword(values).unwrap().catch(() => null);
    navigate('/reset-password', { state: { email: values.email } });
  };

  return (
    <div>
      <h1 className="text-xl font-semibold text-foreground mb-1">Reset your password</h1>
      <p className="text-sm text-foreground-muted mb-6">Enter your email and we'll send you a 6-digit code.</p>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4" noValidate>
        <Input label="Email address" type="email" error={errors.email?.message} {...register('email')} />
        <Button type="submit" className="w-full" isLoading={isLoading}>
          Send code
        </Button>
      </form>

      <p className="text-sm text-foreground-muted mt-6 text-center">
        <Link to="/login" className="text-accent hover:underline">
          Back to login
        </Link>
      </p>
    </div>
  );
}
